function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPegasusReload = function SvgPegasusReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.12 17.12",
    style: {
      enableBackground: "new 0 0 17.12 17.12"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M8.661.001h.034c.019-.002.027 0 .039 0a8.58 8.58 0 0 1 5.955 2.42L16.447.645a.286.286 0 0 1 .314-.065.297.297 0 0 1 .186.271l-.294 6.066h-5.715a.294.294 0 0 1-.145-.548l1.73-1.751c-1.026-.988-2.36-1.529-3.832-1.529-2.993.017-5.433 2.47-5.433 5.51.023 2.978 2.457 5.4 5.481 5.422a5.511 5.511 0 0 0 4.719-3.221l2.803 1.293-.019.039c-1.92 3.713-4.946 5.277-8.192 4.944-4.375-.348-7.848-4.013-7.878-8.52C.171 3.876 3.976.042 8.661.001z"
  }));
};

export default SvgPegasusReload;